/**
 * Zwraca stringa rozpoczętego z wielkiej litery
 *
 * @export
 * @param {string} str
 * @returns {string}
 */
export function capitalize(str: string) {
  if (!str) {
    return '';
  }
  return str.charAt(0).toUpperCase() + str.substring(1);
}

export function removeErrorPrefix(errorMessage: string): string | undefined {
  const errorRegex = /^Error: /i;
  if (typeof errorMessage === 'string') {
    return errorMessage.replace(errorRegex, '');
  }
  return undefined;
}
